export const READ_EVENT_RESOURCES_LIST = `READ_EVENT_RESOURCES_LIST`
export const READ_EVENT_RESOURCES_LIST_SUCCEEDED = `READ_EVENT_RESOURCES_LIST_SUCCEEDED`
export const READ_EVENT_RESOURCES_LIST_FAILED = `READ_EVENT_RESOURCES_LIST_FAILED`

export const RESET_EVENT_RESOURCES_LIST = `RESET_EVENT_RESOURCES_LIST`

export const READ_EVENT_AVAILABLE_RESOURCES_LIST = `READ_EVENT_AVAILABLE_RESOURCES_LIST`
export const READ_EVENT_AVAILABLE_RESOURCES_LIST_SUCCEEDED = `READ_EVENT_AVAILABLE_RESOURCES_LIST_SUCCEEDED`
export const READ_EVENT_AVAILABLE_RESOURCES_LIST_FAILED = `READ_EVENT_AVAILABLE_RESOURCES_LIST_FAILED`

export const ADD_EVENT_RESOURCE = `ADD_EVENT_RESOURCE`
export const ADD_EVENT_RESOURCE_SUCCEEDED = `ADD_EVENT_RESOURCE_SUCCEEDED`
export const ADD_EVENT_RESOURCE_FAILED = `ADD_EVENT_RESOURCE_FAILED`

export const DELETE_EVENT_RESOURCE = `DELETE_EVENT_RESOURCE`
export const DELETE_EVENT_RESOURCE_SUCCEEDED = `DELETE_EVENT_RESOURCE_SUCCEEDED`
export const DELETE_EVENT_RESOURCE_FAILED = `DELETE_EVENT_RESOURCE_FAILED`
